<template>
  <section class="bg-accent-lighter overflow-hidden">
    <div class="bg-white min-h-screen text-primary sm:mx-10 md:mx-40 xl:mx-64 mt-40 p-8 sm:p-16">
      <h1 class="text-title font-semibold" v-text="page.title"/>
      <div class="w-10/12 mb-8" v-html="page.tekst"/>
      <search-bar class="-mx-8 sm:mx-0"/>
      <div v-if="publications.length > 0">
        <article-card
          v-for="(article, index) in publications"
          :key="article.slug"
          :content="article"
          :index="index"
          :publication="publications"
        />
      </div>
      <div v-if="!publications.length > 0 && !loading" class="mt-12">
        Sorry, er zijn nog geen publicaties beschikbaar.
      </div>
    </div>
    <intersection v-if="!loading && nextPage" @intersect="getNextPage"/>
  </section>
</template>

<i18n>
{
  "en": {
  "Geen publicaties gevonden": "No publications found"
  },
  "nl": {
  "Geen publicaties gevonden": "Geen publicaties gevonden"
  }
}
</i18n>

<script>
import page from '~/plugins/mixins/page';
import publications from '~/plugins/mixins/publications';
import ArticleCard from '~/components/ArticleCard';
import SearchBar from '~/components/SearchBar';

export default {
  components: {
    ArticleCard,
    SearchBar,
  },
  mixins: [page, publications],
};
</script>
